import React from 'react'
import { Dropdown } from 'primereact/dropdown'

const WORK_TYPE_OPTIONS = [
    { label: 'TV/Radio', value: 'TVR' },
    { label: 'Books', value: 'BKS' },
    { label: 'Articles', value: 'ART' }
]

/**
 * Work Type filter template with dropdown for TVR/BKS/ART selection
 * @param {object} options - Filter options from PrimeReact column
 */
const WorkTypeFilterTemplate = ({ options }) => {
    return (
        <Dropdown
            value={options.value}
            options={WORK_TYPE_OPTIONS}
            optionLabel="label"
            optionValue="value"
            onChange={(e) => options.filterCallback(e.value, options.index)}
            placeholder="Select Work Type"
            className="p-column-filter"
            showClear
        />
    )
}

export default WorkTypeFilterTemplate
